export const CONTACT_EMAIL = "contact-api@labonnealternance.apprentissage.beta.gouv.fr"
